import React, { useEffect } from 'react';
import {
  commissionTypeOptions,
  envOptions,
  notAllowedEnvs,
} from '../../../Utilities/Utilities';
import {
  AutocompleteComponent,
  Inputs,
  SelectComponet,
} from '../../../../../../Components';
import FieldWithLabel from '../../../../../../Components/FieldWithLabel/FieldWithLabel';
import { config } from '../../../../../../config';

export default function EntityRevenueFields({
  parentTranslationPath,
  translate,
  setState,
  selectedValue,
  entitySources,
  setSelectedValue,
  activeItem,
  entityCommission,
}) {
  useEffect(() => {
    if (activeItem) {
      setState((prev) => ({
        ...prev,
        entityCommissionSettingId: activeItem.entityCommissionSettingId,
        leadXchangeEntitySourceId: activeItem.leadXchangeEntitySourceId,
        commissionType: activeItem.commissionType,
        commissionValue: activeItem.commissionValue,
      }));
      setSelectedValue((prev) => ({
        ...prev,
        entitySource: activeItem,
        commissionType: activeItem.commissionType,
        commissionValue: activeItem.commissionValue,
      }));
    }
  }, [activeItem]);
  return (
    <>
      <FieldWithLabel
        hideDivider
        label={translate('entity')}
        component={
          <AutocompleteComponent
            wrapperClasses={activeItem ? 'w-100' : 'w-50'}
            idRef='EntityRef'
            withoutSearchButton
            multiple={false}
            parentTranslationPath={parentTranslationPath}
            inputPlaceholder={'select'}
            inputClasses='fields-content'
            data={entitySources ?? []}
            selectedValues={selectedValue?.entitySource}
            isDisabled={activeItem}
            filterOptions={(options) =>
              options
                .filter((option) => {
                  if (envOptions.includes(config.name)) return true;
                  return !notAllowedEnvs.includes(option.entitySourceName);
                })
                .filter(
                  (option) =>
                    !entityCommission?.some(
                      (item) =>
                        item.systemSourceName === option.entitySourceName
                    )
                )
            }
            displayLabel={(option) =>
              option?.entitySourceName ?? option?.systemSourceName
            }
            chipsLabel={(option) =>
              option?.entitySourceName ?? option?.systemSourceName
            }
            onChange={(_, newValue) => {
              setState((prev) => ({
                ...prev,
                leadXchangeEntitySourceId: newValue?.entitySourceId,
              }));
              setSelectedValue((prev) => ({
                ...prev,
                entitySource: newValue,
              }));
            }}
          />
        }
      />
      {activeItem && <hr className='hr-divider' />}
      <FieldWithLabel
        hideDivider
        label={translate('commission_type')}
        component={
          <SelectComponet
            wrapperClasses={`fields-content ${activeItem ? 'w-100' : 'w-50'}`}
            idRef='commissionRef'
            placeholder='select'
            data={commissionTypeOptions}
            valueInput='value'
            textInput='text'
            parentTranslationPath={parentTranslationPath}
            value={selectedValue?.commissionType}
            emptyItem={{
              value: null,
              text: 'Select',
              isDisabled: false,
            }}
            onSelectChanged={(newValue) => {
              setState((prev) => ({
                ...prev,
                commissionType: newValue,
              }));
              setSelectedValue((prev) => ({
                ...prev,
                commissionType: newValue,
              }));
            }}
          />
        }
      />
      {activeItem && <hr className='hr-divider' />}
      <FieldWithLabel
        hideDivider
        label={translate('value')}
        component={
          <Inputs
            wrapperClasses={activeItem ? 'w-100' : 'w-50'}
            idRef='valueRef'
            inputPlaceholder={'enter'}
            type='number'
            fieldClasses='fields-content'
            onInputChanged={(e) => {
              const newValue = e.target.value;
              setState((prev) => ({
                ...prev,
                commissionValue: +newValue,
              }));
              setSelectedValue((prev) => ({
                ...prev,
                commissionValue: +newValue,
              }));
            }}
            value={selectedValue?.commissionValue}
            parentTranslationPath={parentTranslationPath}
            isWithError
            error={
              selectedValue?.commissionType === 2 &&
              selectedValue?.commissionValue > 100
            }
            helperText={
              selectedValue?.commissionType === 2 &&
              selectedValue?.commissionValue > 100
                ? 'Please enter a valid commission value.'
                : ''
            }
          />
        }
      />
    </>
  );
}
